export default __webpack_public_path__ + "static/media/logo.632047ae.png";